import React from "react";

/**
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {string=} props.textColor
 * @param {(e:any) => void} props.onClick
 * @returns
 */
function LinkButton({ label, textColor, onClick }) {
  return (
    <button
      type="button"
      className={`arh-border-0 arh-bg-transparent arh-font-poppins arh-text-[11px] arh-font-medium arh-underline arh-underline-offset-2 ${textColor}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

export default LinkButton;
